import { CardFooter as UICardFooter } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

interface CardFooterProps {
  playerName?: string;
}

export function SharedCardFooter({ 
  playerName,
}: CardFooterProps) {
  const navigate = useNavigate();

  const handleUserClick = (e: React.MouseEvent) => {
    e.preventDefault(); // Prevent any default behavior
    
    if (playerName) {
      console.log('Navigating to profile:', playerName);
      navigate(`/profile/${playerName}`, { replace: false }); // Don't use replace here
    } else {
      console.log('No username provided for navigation');
    }
  };

  return (
    <UICardFooter className="border-t border-white/20 p-4 flex-col gap-2">
      <div className="w-full text-sm text-gray-400">
        By{" "}
        {playerName ? (
          <button 
            onClick={handleUserClick}
            className="hover:text-white hover:underline transition-colors"
          >
            {playerName || 'Anonymous'}
          </button>
        ) : (
          <span>{playerName || 'Anonymous'}</span>
        )}
      </div>
      {/* TODO: Add back in with proper functionality */}
      {/* <div className="flex justify-between w-full">
        <div className="flex gap-4">
          <Button 
            variant="ghost" 
            size="icon" 
            className={isLiked ? "text-red-400" : "text-white"}
          >
            <Heart className="h-6 w-6" />
          </Button>
          <Button variant="ghost" size="icon" className="text-white">
            <MessageCircle className="h-6 w-6" />
          </Button>
          <Button variant="ghost" size="icon" className="text-white">
            <Share2 className="h-6 w-6" />
          </Button>
        </div>
        <Button variant="ghost" size="icon" className="text-white">
          <Bookmark className="h-6 w-6" />
        </Button>
      </div> */}
    </UICardFooter>
  );
} 